
import React from 'react';
import DataDownload from '../../core/DataDownload';
import GenerateTSV from '../../core/TSV/GenerateTSV';
import PropTypes from 'prop-types';
import workerCode from '../workers/tsv-export.js';
import { SKOS_DATATYPE_CONFIGURATION, SKOS_OBJECT_CONFIGURATION } from '../constants';
import TabbedSubmenu from '../../core/TabbedSubmenu.js';

class CollectionExport extends React.Component {

    render() {

        const { id, graph, ordered, skosXL, defaultLang, ontologyProjectAssociation, entitlements, examples, annotations } = this.props;

        return (
            <TabbedSubmenu tabs={["Download Data", "Generate CSV/HTML/TSV/XLSX"]}>
                <DataDownload
                    title="Collection"
                    skosXLoption={skosXL}
                    annotationOption={annotations}
                    graph={graph}
                    resource={id}
                    exportName={ordered ? "collectionexport" : "unorderedcollectionexport"}
                    message="Downloading the collection will include data for the collection and all concepts that are members of it." />
                <GenerateTSV
                    ontologyProjectAssociation={ontologyProjectAssociation}
                    tsvFunction={workerCode}
                    entitlements={entitlements}
                    tsvMode="collection"
                    examples={examples}
                    graph={graph}
                    options={{
                        labelProp: 'prefLabel',
                        columns: {
                            "https://grafsync.graphifi.com/schema/tsv/concepts": "Concepts",
                            "https://grafsync.graphifi.com/schema/tsv/IRI": "IRI"
                        },
                        ordered,
                        datatypeProperties: SKOS_DATATYPE_CONFIGURATION,
                        objectProperties: Object.assign({}, SKOS_OBJECT_CONFIGURATION, {
                            "type": {
                                "displayName": "Class",
                                "iri": "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
                            }
                        })
                    }}
                    defaultLang={defaultLang}
                    resource={this.props.id}
                    labelsExportName={ordered ? "collection" : "unorderedcollection"}
                    exportName={ordered ? "collection" : "unorderedcollection"} />
            </TabbedSubmenu>
        );
    }
}

CollectionExport.defaulatProps = {
    skosXL: false,
    annotations: false
};

CollectionExport.propTypes = {
    entitlements: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    examples: PropTypes.array,
    ordered: PropTypes.bool.isRequired,
    graph: PropTypes.string.isRequired,
    skosXL: PropTypes.bool,
    annotations: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    ontologyProjectAssociation: PropTypes.array
};

export default CollectionExport;